import {useContext} from "react";
import {ServerContext} from "src/server/components/context";

export default function useServerContext() {
  return useContext(ServerContext);
}
